import React from "react";
import {
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Switch,
  Typography,
} from "@mui/material";
import dayjs from "utils/dayjs";
import SettingPolicyType from "enums/SettingPolicyType";
import { TransactionPolicy } from "hooks/settingPolicy.types";
import { Stack } from "components/layout/reusableLayouts";
import { PANE_BORDER, PANE_PADDING_X, rowGapSx } from "./paneLayout";

interface PolicyTypePaneProps {
  policies: TransactionPolicy[];
  selectedType: SettingPolicyType;
  getTitle: (type: SettingPolicyType) => string | undefined;
  onSelectType: (type: SettingPolicyType) => void;
  onToggleEnabled: (policy: TransactionPolicy) => void;
}

const PolicyTypePane: React.FC<PolicyTypePaneProps> = ({
  policies,
  selectedType,
  getTitle,
  onSelectType,
  onToggleEnabled,
}) => (
  <List sx={{ padding: PANE_PADDING_X, borderRight: PANE_BORDER }}>
    {policies.map((item, index) => (
      <ListItem
        disablePadding
        key={item.id}
        sx={rowGapSx(index, policies.length)}
      >
        <ListItemButton
          selected={selectedType === item.type}
          onClick={() => onSelectType(item.type)}
        >
          <ListItemText
            primary={
              <Stack gap="0">
                <Typography component="span" variant="body1">
                  {getTitle(item.type)}&nbsp;
                </Typography>
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ color: "var(--color-text-tertiary)" }}
                >
                  {`(Last edited ${dayjs(item.updatedAt).format("MMM DD-YYYY")})`}
                </Typography>
              </Stack>
            }
          />
          <FormControlLabel
            sx={{ marginRight: 0 }}
            control={
              <Switch
                checked={Boolean(item.isPolicyTypeEnabled)}
                onChange={() => onToggleEnabled(item)}
                color="primary"
                // The visible title belongs to the row, not the switch, so the
                // control needs its own name or it reads as an unnamed toggle.
                slotProps={{ input: { "aria-label": getTitle(item.type) } }}
              />
            }
            label=""
          />
        </ListItemButton>
      </ListItem>
    ))}
  </List>
);

export default PolicyTypePane;
